var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8523_31530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9773 0.900391H6.60531C6.04047 0.900391 5.58203 1.35602 5.58203 1.91758V6.45039L15.0705 9.22539L24.0006 6.45039V1.91758C24.0006 1.35555 23.5427 0.900391 22.9773 0.900391Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 6.44922H5.58203V11.9992L15.0705 13.6642L24.0006 11.9992V6.44922Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58203 12V17.55L14.5122 18.66L24.0006 17.55V12H5.58203Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60531 23.1008H22.9778C23.5427 23.1008 24.0011 22.6452 24.0011 22.0836V17.5508H5.58203V22.0836C5.58203 22.6456 6.04 23.1008 6.60531 23.1008Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3728 5.33984H5.58203V19.2148H12.3728C12.9372 19.213 13.3942 18.7587 13.3961 18.1977V6.35703C13.3942 5.79594 12.9372 5.34172 12.3728 5.33984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.815 5.89453H5.58203V19.7695H11.815C12.3794 19.7677 12.8364 19.3134 12.8383 18.7523V6.91172C12.8359 6.35063 12.3789 5.89641 11.815 5.89453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.815 5.89453H5.58203V18.6595H11.815C12.3794 18.6577 12.8364 18.2034 12.8383 17.6423V6.91172C12.8359 6.35063 12.3789 5.89641 11.815 5.89453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2567 5.89453H5.58203V18.6595H11.2567C11.8211 18.6577 12.2781 18.2034 12.28 17.6423V6.91172C12.2777 6.35063 11.8211 5.89641 11.2567 5.89453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02328 5.89453H11.2561C11.8209 5.89453 12.2794 6.35016 12.2794 6.91172V17.0873C12.2794 17.6494 11.8214 18.1045 11.2561 18.1045H1.02328C0.457969 18.1045 0 17.6489 0 17.0873V6.91172C0 6.35016 0.457969 5.89453 1.02328 5.89453Z",
    fill: "url(#paint0_linear_8523_31530)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1982 13.6981C4.21836 13.8552 4.23148 13.9916 4.23805 14.1088H4.26148C4.27039 13.9977 4.28914 13.8641 4.31727 13.7075C4.34539 13.5509 4.37117 13.4188 4.39367 13.3105L5.46992 8.69375H6.86117L7.97727 13.2411C8.04195 13.5237 8.08836 13.8106 8.11602 14.0989H8.1343C8.15492 13.8191 8.19383 13.5411 8.25055 13.2664L9.1407 8.69141H10.4073L8.84352 15.3069H7.36414L6.30383 10.9255C6.27336 10.7994 6.2382 10.6348 6.1993 10.4319C6.16039 10.2289 6.13695 10.0813 6.12711 9.98797H6.10883C6.09664 10.0958 6.07273 10.2556 6.03664 10.4675C6.00102 10.6794 5.97242 10.8364 5.95086 10.9381L4.95383 15.3055H3.44914L1.87695 8.69422H3.16602L4.13539 13.3203C4.15789 13.415 4.17852 13.5416 4.1982 13.6981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8523_31530",
    x1: 2.14773,
    y1: 5.08586,
    x2: 10.1314,
    y2: 18.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8523_31530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.f8232f1744aa97e8ca03271a12cc568e.svg";
export { ForwardRef as ReactComponent };